import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";

export const HeaderContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  padding: "1rem",
  gap: "1rem",
  marginLeft: "1rem",
}));

export const ContentContainer = styled(Box)(() => ({
  width: "1254px",
  display: "flex",
  gap: "24px",
  position: "relative",
}));

export const AdditionalInfoFormContainer = styled(Box)(() => ({
  flex: 2,
  backgroundColor: "#fff",
  padding: "1rem",
  borderRadius: "12px",
  height: "100%",
}));

export const LongOrderFormContainer = styled(Box)(() => ({
  flex: 2,
  backgroundColor: "#fff",
  borderRadius: "12px",
  height: "100%",
}));

export const PreviewContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  height: "fit-content",
  gap: "32px",
  alignItems: "center",
  marginRight: "24px",
}));

export const PreviewNotificationContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  backgroundColor: "#fff",
  borderRadius: "12px",
  padding: "1rem 1rem 1rem 1rem",
  height: "86px",
  width: "342px",
  boxShadow: "0px 4px 22px rgba(26, 42, 97, 0.08)",
}));

export const SelectedOrderFormLongOrderRowContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  backgroundColor: "#EAEAF1",
  borderRadius: "12px",
  padding: "0.5rem",
  width: "295px", //TODO: do this without width?
}));
export const OrderFormLongOrderRowContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  borderRadius: "12px",
  padding: "0.5rem",
  width: "295px",
}));
export const PreviewNotificationText = styled(Typography)(() => ({
  fontSize: "14px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  display: "inline-block",
  maxWidth: "220px",
  lineHeight: "18px",
}));

export const PreviewNotificationUnread = styled(Box)(() => ({
  borderRadius: "100%",
  backgroundColor: "#E20B06",
  width: "7px",
  height: "7px",
  position: "absolute",
  transform: "translate(18px, -32px)",
}));

export const PreviewFullContainer = styled(Box)(() => ({
  flex: 1,
  backgroundColor: "#fff",
  borderRadius: "12px",
  width: "100%",
  boxShadow: "0px 4px 22px rgb(26 42 97 / 8%)",
}));

export const PreviewImage = styled(Box)(() => ({
  height: "220px",
  background:
    "linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.04) 25%)", // TODO: image???
  borderTopLeftRadius: "10px",
  borderTopRightRadius: "10px",
}));

export const ButtonsContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  height: "70px",
  position: "sticky",
  bottom: 0,
  left: 0,
  backgroundColor: "#EAEAF1",
  padding: "1rem",
  borderTop: "1px solid #4A1D9C1F",
}));

export const Backdrop = styled(Box)(() => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "transparent",
}));

export const PreviewShiftContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "multipleShifts",
})<{ multipleShifts: boolean }>(({ multipleShifts }) => ({
  display: "flex",
  flexDirection: multipleShifts ? "row" : "column",
  gap: multipleShifts ? "34px" : "12px",
  marginBottom: "12px",
}));

export const PreviewShiftItem = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
}));
